
    <div class="invites">
      <div *ngIf="!invites.length" class="no-invite">
        <img src="assets/shared/img/svg/sad_face.svg" alt="Sem vouchers">
        <p>Parece que ninguém se cadastrou ainda. Continue indicando!</p>
        <button class="btn" routerLink="/indique">Indique agora</button>
      </div>

      <div class="invites-list" *ngIf="invites.length">

        <div class="description">
          <h2>Indicados que se cadastraram</h2>
          <b>{{invites.length}} {{invites.length > 1 ? 'Amigos' : 'Amigo'}}</b>
        </div>

        <invitation-accepted
          class="invites-card"
          [hideButton]="true"
          [invites]="invites">
        </invitation-accepted>
      </div>

    </div>
  